import {z} from 'zod'
import {NoContent} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {raise} from '@utilities/helpers.ts'
import {ProjectMedicalReport} from '@/features/medical-reports/types'
import {httpGetPreviousReportByProject} from '@/features/medical-reports/http/medicalReports.http'

const ResponseShape = ProjectMedicalReport.or(NoContent)
type ResponseShape = z.infer<typeof ResponseShape>

export const useGetPreviousReportByProject = ({
    projectId,
    medicalReportTypeId,
    options
}: {
    projectId?: string
    medicalReportTypeId?: string
    options?: Omit<UseQueryOptions<ResponseShape>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORTS, projectId, medicalReportTypeId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetPreviousReportByProject({
                    urlParams: {projectId: projectId ?? raise('projectId is nullish')},
                    params: {
                        medicalRecordReportTypeId: medicalReportTypeId ?? raise('medicalReportTypeId is nullish'),
                        responseType: 'extended'
                    }
                }),
                onZodError: captureException,
                responseShape: ResponseShape
            }),
        ...options
    })
